import { IonContent } from "@ionic/react";
import WithHeader, { TitleSize } from "../with-header";
import { HintsDef } from "../../components/common/tvm-form/form-definition";

interface withNavigationProps {
	text?: string;
	// Kept for backwards compatibility with callers; no-op since the license
	// flow was removed (April 2026).
	checkUser?: boolean;
	showLogo?: boolean;
	className?: string;
	preventGoBack?: boolean;
	titleSize?: TitleSize;
	hintsContent?: HintsDef;
	onClick?: () => void;
}

const WithNavigation: React.FC<withNavigationProps> = (props): JSX.Element => {
	const {
		showLogo = false,
		className,
		text,
		children,
		titleSize = "large",
		preventGoBack = false,
		hintsContent = undefined,
	} = props;

	return (
		<WithHeader
			className={className}
			showUser={false}
			showLogo={showLogo}
			title={text}
			preventGoBack={preventGoBack}
			titleSize={titleSize}
			hintsContent={hintsContent}
		>
			<IonContent fullscreen>{children}</IonContent>
		</WithHeader>
	);
};

export default WithNavigation;
